/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { RouterInfoService } from '../services/router-info.service';
import { ToastController } from '@ionic/angular';
import { Key } from 'protractor';

@Component({
  selector: 'app-router-info',
  templateUrl: './router-info.component.html',
  styleUrls: ['./router-info.component.scss'],
})
export class RouterInfoComponent implements OnInit {

  userType: 'pppoe' | 'hotspot' = 'pppoe';
  editModes: { [index: number]: boolean } = {};

  // wifiData: any = { SSID: '', KeyPassphrase: '', ssidCount: 1, downloadSpeed: 0, uploadSpeed: 0 };
  wifiData: any[] = [];

  userInfo: any = {};
  connectedDevices: any[] = [];
  dataConsumption: any = { used: 0, quota: 0 };

  tr069Stats: any = {}; // contains WAN, WLAN, associatedDevices, etc.

  isEditing = false;
  originalValues: any = {};
  changedFields: any = {};

  constructor(
    private routerInfoService: RouterInfoService,
    private toastController: ToastController,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.userType = this?.userType === 'pppoe' ? 'pppoe' : 'hotspot';

    // this.routerInfoService.getUserDetails().subscribe(res => {
    //   this.userInfo = res;
    // });

    if (this.userType === 'pppoe') {
      const sessionId = localStorage.getItem('sn') || '48575443EDA91A8C';
      const deviceId = ''; // Ensure deviceDetails is already populated

      // Call TR-069 data loader
      this.loadWifiData(deviceId, sessionId, 'wifi');

      this.routerInfoService.connect(deviceId, sessionId).subscribe(isConnected => {
        console.log('WebSocket connection status:', isConnected);
      });

      // this.routerInfoService.getWifiSettings().subscribe(settings => {
      //   this.wifiData.ssid = settings?.ssid || '';
      //   this.wifiData.password = settings?.password || '';
      //   this.originalValues = { ssid: this.wifiData.ssid, password: this.wifiData.password };
      //   this.cdr.detectChanges();
      // });

      // this.routerInfoService.getConnectedDevices().subscribe(devices => {
      //   this.connectedDevices = devices;
      //   this.cdr.detectChanges();
      // });



      // this.routerInfoService.getWifiUpdates().subscribe(data => {
      //   if (data) {
      //     console.log('Received WiFi update:', data);

      //     const config = data[0];


      //     this.wifiData = { ...this.wifiData, ...config };
      //     if (data?.SSID) { this.changedFields.SSID = config.SSID; }
      //     if (data?.KeyPassphrase) { this.changedFields.KeyPassphrase = config.KeyPassphrase; }

      //     this.cdr.detectChanges();
      //   }
      // });

      this.routerInfoService.getWifiUpdates().subscribe(data => {
        if (Array.isArray(data)) {
          this.wifiData = data;

          this.changedFields = data.map(config => ({
            SSID: config.SSID,
            KeyPassphrase: config.KeyPassphrase,
            ssidCount: config.ssidCount
          }));

          this.cdr.detectChanges();
        }
      });




      this.routerInfoService.getConnectedDevicesUpdates().subscribe(devices => {
        this.connectedDevices = devices;
        this.cdr.detectChanges();
      });
    }

    if (this.userType === 'hotspot') {
      this.routerInfoService.getDataConsumption().subscribe(res => {
        this.dataConsumption = res;
      });
    }
  }

  toggleEditMode(index: number) {
    this.editModes[index] = !this.editModes[index];
  }


  /**
   * Fetch and populate TR069 statistics.
   */
  handleChange(field: 'SSID' | 'KeyPassphrase', event: any) {
    const value = (event as CustomEvent).detail.value;
    this.onFieldChange(field, value);
  }

  onFieldChange(field: 'SSID' | 'KeyPassphrase', value: string) {
    this.changedFields[field] = value;
  }
  async saveChanges(index: number) {
    const changes = this.changedFields[index];
    const original = this.wifiData[index];

    if (!changes || (!changes.SSID && !changes.KeyPassphrase)) {
      const toast = await this.toastController.create({
        message: 'No changes detected.',
        duration: 2000,
        color: 'warning',
      });
      await toast.present();
      return;
    }

    const sessionId = localStorage.getItem('sn') || '48575443EDA91A8C';
    const deviceId = ''; // TODO: Set your actual deviceId
    const ssidCount = original.ssidCount;

    // If SSID has changed, call saveSsidConfig
    if (changes.SSID) {
      const payload = {
        ssid: changes.SSID,
        password: changes.KeyPassphrase || original.KeyPassphrase,
        ssidCount
      };

      this.routerInfoService.saveSsidConfig(payload).subscribe({
        next: async () => {
          const toast = await this.toastController.create({
            message: `SSID updated successfully for config ${index + 1}.`,
            duration: 3000,
            color: 'success',
          });
          await toast.present();
          this.loadWifiData(deviceId, sessionId, 'wifi');
        },
        error: async () => {
          const toast = await this.toastController.create({
            message: 'Failed to update SSID.',
            duration: 3000,
            color: 'danger',
          });
          await toast.present();
        }
      });

    } else if (changes.KeyPassphrase) {
      // Only password changed
      this.routerInfoService.updatePassword(deviceId, changes.KeyPassphrase, sessionId, ssidCount).subscribe({
        next: async () => {
          const toast = await this.toastController.create({
            message: `Password updated successfully for config ${index + 1}.`,
            duration: 3000,
            color: 'success',
          });
          await toast.present();
          this.loadWifiData(deviceId, sessionId, 'wifi');
        },
        error: async () => {
          const toast = await this.toastController.create({
            message: 'Failed to update password.',
            duration: 3000,
            color: 'danger',
          });
          await toast.present();
        }
      });
    }

    this.editModes[index] = false;
    this.changedFields[index] = {};
  }


  loadWifiData(deviceId: string, sessionId: string, endpoint: string) {
    this.routerInfoService.fetchWifiData(deviceId, sessionId, endpoint).subscribe(
      (response: any) => {
        if (response) {
          console.log(`${endpoint} response data`, response);
        } else {
          console.error(`Unexpected response format for ${endpoint}:`, response);
          // this.showError(`Failed to load TR069 ${endpoint}`);
        }
        // this.loading = false;
      },
      (error) => {
        console.log(`Error fetching TR069 ${endpoint}`, error);
        // this.loading = false;
        // this.showError(`Failed to load TR069 ${endpoint}`);
      }
    );
  }



  // updateWifiSettings() {
  //   this.saveChanges();
  // }
}
